import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectWorkersInfo } from "../../../../selectors/selectWorkersInfo";
export var checkBuildingUpgradeHasEnoughWorker = function (path) { return function (action, state$) {
    var state = state$.value;
    var building = action.building;
    var upgradeInfo = selectBuildingUpgradeInfo(building);
    if (upgradeInfo.nextStage &&
        upgradeInfo.currentStage.workers &&
        upgradeInfo.nextStage.workers) {
        if (upgradeInfo.currentStage.workers > upgradeInfo.nextStage.workers) {
            var requiredWorkerCount = upgradeInfo.currentStage.workers - upgradeInfo.nextStage.workers;
            var availableWorkers = selectWorkersInfo(state).free;
            if (availableWorkers < requiredWorkerCount) {
                return path;
            }
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingUpgradeHasEnoughWorker.ts
// module id = 2075
// module chunks = 3